import { resolveComponent as _resolveComponent, createVNode as _createVNode, resolveDynamicComponent as _resolveDynamicComponent, openBlock as _openBlock, createBlock as _createBlock, Transition as _Transition, withCtx as _withCtx } from "vue";
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_notifications = _resolveComponent("notifications");
  const _component_b_orchestrator = _resolveComponent("b-orchestrator");
  const _component_router_view = _resolveComponent("router-view");
  return _openBlock(), _createBlock(_resolveDynamicComponent($options.layout), {
    id: "app",
    class: "container-fluid",
    style: {
      "padding-left": "0% !important",
      "padding-right": "0% !important"
    }
  }, {
    default: _withCtx(() => [_createVNode(_component_notifications, {
      group: "errors",
      ignoreDuplicates: true,
      max: 1,
      role: "status"
    }), _createVNode(_component_notifications, {
      group: "notices",
      ignoreDuplicates: true,
      max: 1,
      role: "status"
    }), _createVNode(_component_b_orchestrator), _createVNode(_component_router_view, null, {
      default: _withCtx(({
        Component
      }) => [_createVNode(_Transition, {
        name: $data.transitionName
      }, {
        default: _withCtx(() => [(_openBlock(), _createBlock(_resolveDynamicComponent(Component)))], undefined, true),
        _: 2
      }, 1032, ["name"])]),
      _: 1
    })], undefined, true),
    _: 1
  });
}